module.exports = __webpack_public_path__ + "static/img/06-04.a1413eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/06-04.png
// module id = s+al
// module chunks = 0